module.exports = __webpack_public_path__ + "aj.no1.051a4f0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aj.no1.jpg
// module id = tRFU
// module chunks = 0